"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TaskRunner = void 0;
// enqueues tasks to a task-queue
class TaskRunner {
    /**
     * creates a new TaskRunner; does not start automatically
     * @param speed - frequency between new job checks (1 = every second, 2 - twice/second, etc)
     * @param tasks - task queue to use for jobs
     */
    constructor(speed = 2, tasks = []) {
        this.taskQueue = tasks;
        this.delay = Math.floor(1000 / speed);
        this.jobRunning = false;
    }
    /**
     * enqueue a new task to the task-queue; if we're not running yet start runner
     * @param task new task to execute
     */
    push(task) {
        this.taskQueue.push(task);
        if (!this.jobRunning)
            this.run();
    }
    /** processes a task from the task-queue; if the queue is empty set jobRunning to false */
    run() {
        if (this.taskQueue.length) {
            const task = this.taskQueue.shift();
            this.process(task);
        }
        else {
            this.jobRunning = false;
        }
    }
    /**
     * executes the provided task immediately
     * @param task
     */
    process(task) {
        this.jobRunning = true;
        setTimeout(() => {
            void task();
            this.run();
        }, this.delay);
    }
}
exports.TaskRunner = TaskRunner;
//# sourceMappingURL=TaskRunner.js.map